import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { IconCloudStorm } from "@tabler/icons-react";

import styles from "./header.module.css";

export default function Header() {
    return (
    <div className={styles.header}>
        <div className={styles.headerLeft}>
          <Typography variant="h5" className={styles.title}>Storm Strategy</Typography>
          <Typography variant="subtitle1" className={styles.subtitle}>
            Create and send storm strategies to your sites
          </Typography>
        </div>
        <Button
          variant="contained"
          onClick={() => window.location.href = '/bulk-storm-strategy'}
          startIcon={<IconCloudStorm size={20} />}
          className={styles.bulkButton}
        >
          Bulk Storm Strategy
        </Button>
      </div>
    )
}